import { useCallback } from 'react'

import { useStudioTimezone } from '@/features/actions/hooks/useStudioTimezone'
import { pipelineSummary } from '@/features/actions/pipelineSummary'
import { useAuth } from '@/features/auth/authContext'
import type { PipelineState } from '@/types/models'

/**
 * `pipelineSummary` bound to the session, so an action's toast does not have to
 * collect the studio's zone and its today for itself. Both must come from the
 * session: the dates in the block are the *location's*, not the browser's.
 */
export function usePipelineSummary(): (pipeline: PipelineState | null) => string | null {
  const timezone = useStudioTimezone()
  const { today } = useAuth()

  return useCallback(
    (pipeline: PipelineState | null) => pipelineSummary(pipeline, timezone, today),
    [timezone, today],
  )
}
